<template>
  <div class='indexbox'>
    <div class="searchbox">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><a href="goods">{{ $t("lg.商品匹配") }}</a></el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('lg.导入') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tablebox">
      <div class="bodybox">
        <div class="topbox">
          <div class="left">
            <div class="left">
              <p>{{ $t('lg.步骤') }}1</p>
              <p>{{ $t('lg.下载商品匹配列表导入模板') }}</p>
              <p>{{ $t('lg.该模板文件包含了导入商品匹配数据所需要的所有字段') }}</p>
            </div>
          </div>
          <el-button @click="downloaddata" :loading='btn_loadinga'>{{ $t('lg.下载Excel模板') }}</el-button>
        </div>
      </div>
      <div class="bodybox">
        <div class="topbox" style="margin-bottom:20px;">
          <div class="left">
            <div class="left">
              <p>{{ $t('lg.步骤') }}2</p>
              <p>{{ $t('lg.复制商品匹配列表到模板') }}</p>
              <p>{{ $t('lg.分别从DEAR和平台中导出产品列表，将导出文件中的产品复制并粘贴到下载的模板中，确保复制的数据与模板中的列标题匹配') }}</p>
            </div>
          </div>
        </div>
        <el-alert :title="$t('lg.为了正确导入数据，请勿修改模板文档中的列标题')" type="error" :closable=false></el-alert>
        <div class="listbox" style="margin-bottom:20px;">
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item :title="$t('lg.字段说明')" name="2">
              <div class="tabbox">
                <p>{{ $t('lg.字段名称') }}</p>
                <p>{{ $t('lg.字段解释') }}</p>
              </div>
              <div class="tablist">
                <p>{{ $t('lg.平台商品代码') }}</p>
                <p>{{ $t('lg.商家用来标识商品的代码') }}</p>
              </div>
              <div class="tablist">
                <p>{{ $t('lg.DEAR商品代码') }}</p>
                <p>{{ $t('lg.DEAR中产品的物料代码，每个产品的物料代码是唯一的') }}</p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="bodybox" style="border:none;">
        <div class="topbox">
          <div class="left">
            <div class="left">
              <p>{{ $t('lg.步骤') }}3</p>
              <p>{{ $t('lg.导入已更新的模板文件') }}</p>
              <p>{{ $t('lg.您导入的文件') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bodybox" v-if="show">
        <div class="draggable" v-loading='loading'>
          <el-table :data="tableData" stripe>
            <el-table-column prop="outerId" :label="$t('lg.产品代码')" align='center' />
            <el-table-column prop="dear_sku" :label="$t('lg.DEAR产品代码')" align='center' />
            <el-table-column prop="error" :label="$t('lg.错误')" align='center' show-overflow-tooltip>
              <template slot-scope="scope">
                <img src="../../assets/img/error@2x.png" @click="opendata(scope.row)" width="25" height="25" alt=""
                  v-if="scope.row.error">
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="bodybox" style="border:none;padding-top:0;">
        <template v-if="show_success">
          <el-alert :title="$t('lg.商品匹配已成功导入')" type="success" :closable=false></el-alert>
        </template>
        <div class="upfile" v-loading='uploading'>
          <el-form ref="form" :model="form" :rules="rules" class="formbox">
            <el-form-item prop="file">
              <el-upload :limit='1' class="upload-demo" action='' drag :auto-upload="false" accept=".xlsx, .xls"
                :on-change="Uploadchange" :on-remove='clearFiles' :file-list="fileList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{ $t('lg.将文件') }}<em>{{ $t('lg.点击上传') }}</em></div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      shop_id: this.$route.query.id,
      status: this.$route.query.status,
      title: this.$route.query.title,
      activeName: '',
      // 导入
      show: false,
      fileList: [],
      form: {
        file: '',
      },
      rules: {
        file: [
          { required: true, trigger: "blur", message: this.$t('lg.请上传文件') }
        ]
      },
      tableData: [],
      uploading: false,
      loading: false,
      btn_loadinga: false,
      show_success: false,
    };
  },
  computed: {
    ...mapGetters(['api_id']),
  },
  methods: {
    //下载Excel模板
    downloaddata() {
      this.btn_loadinga = true
      setTimeout(() => {
        this.btn_loadinga = false
      }, 1200);
      let url = `${this.httpPath}/app/goods/getExcelUrl?token=${getToken()}&shop_id=${this.shop_id}&title=${this.title}&status=${this.status}`
      window.open(url)
      // this.$post({
      //   url: "/app/goods/getExcelUrl",
      //   success: (res) => {
      //     let url = res.data.url
      //     // window.open(url)
      //     setTimeout(() => {
      //       this.btn_loadinga = false
      //     }, 1200);
      //   },
      //   tip: () => {
      //     setTimeout(() => {
      //       this.btn_loadinga = false
      //     }, 1200);
      //   },
      // })
    },
    // 导入 上传file
    Uploadchange(file) {
      this.clearFiles()
      this.form.file = file.raw
      this.loadOrders()
    },
    clearFiles() {
      this.uploading = false
      this.show_success = false
      this.fileList = []
      this.form.file = ''
      this.tableData = []
      this.show = false
    },
    //loadOrders
    loadOrders() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.uploading = true
          let data = new FormData();
          data.append("file", this.form.file);
          data.append("shop_id", this.shop_id);
          data.append("token", getToken());
          this.$post({
            url: "/app/goods/import",
            upload: true,
            data,
            success: (res) => {
              this.uploading = false
              console.log(12, res.data);
              if (res.data.length > 0) {
                this.show = true
                this.loading = true
                this.tableData = res.data
                this.fileList = []
                setTimeout(() => {
                  this.loading = false
                }, 500);
              } else {
                this.clearFiles()
                this.$message({
                  message: this.$t('lg.成功'),
                  type: 'success'
                });
                this.show_success = true
              }
            },
            tip: () => {
              this.clearFiles()
            },
          })
        }
      });
    },
    opendata(data) {
      this.$alert(data.error, {
        showClose: false
      });
    },
  },
}
</script>
<style lang='scss' scoped>
.indexbox {
  width: 100%;
  height: 100%;
  .searchbox {
    width: 100%;
    padding: 20px 30px;
    background: #fff;
    border-bottom: 1px solid #babdcd;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tablebox {
    width: 100%;
    padding: 20px;
    .bodybox {
      width: 100%;
      padding: 20px;
      background: #fff;
      border-bottom: 1px solid #dbdbdb;
      .topbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999999;
        font-size: 14px;
        p:nth-child(1) {
          color: #333333;
          font-weight: 550;
        }
        p:nth-child(2) {
          color: #666666;
          line-height: 2;
        }
      }
      /deep/.el-button--default {
        color: #19cbbf;
        background-color: #fff;
        border-color: #19cbbf;
        border-radius: 4px;
      }
      .listbox {
        width: 100%;
        margin-top: 15px;
        padding: 10px 15px;
        background: #f1f6fb;
        border-radius: 10px;
        .titbox {
          width: 100%;
          color: #999999;
          font-size: 14px;
          p:nth-child(1) {
            color: #333333;
            font-weight: 550;
          }
          p:nth-child(2) {
            padding: 10px 0 20px;
          }
        }
        .tabbox {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          color: #333333;
          font-size: 14px;
          font-weight: 550;
          padding: 8px 0;
          border-bottom: 1px solid #dbdbdb;
          p:nth-child(1) {
            width: 20%;
          }
        }
        .tablist {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          font-weight: 550;
          padding: 8px 0;
          line-height: 1.6;
          p:nth-child(1) {
            width: 20%;
            color: #333333;
            font-size: 14px;
          }
          p:nth-child(2) {
            width: 80%;
            color: #666666;
            font-size: 12px;
          }
        }
        /deep/.el-collapse {
          border: none;
          .el-collapse-item__header {
            background: none;
            color: #333333;
            font-size: 14px;
            font-weight: 550;
          }
          .el-collapse-item__content {
            padding-bottom: 0;
          }
          .el-collapse-item__wrap {
            border-bottom: none;
            background: none;
            .tabtit {
              margin-bottom: 20px;
              color: #999999;
              font-size: 14px;
            }
          }
        }
      }
      /deep/.el-alert--success.is-light {
        background: #d7e4f3;
        color: #333333;
      }
    }
    .bodybox:nth-child(1) {
      border-radius: 10px 10px 0 0;
    }
    .bodybox:last-child {
      border-bottom: none;
      border-radius: 0 0 10px 10px;
      .upfile {
        padding: 10px 0 0;
      }
      /deep/.el-upload-dragger {
        width: 100%;
      }
    }
    .listsbox {
      width: 100%;
      padding: 20px;
      background: #fff;
    }
  }
  .formbox {
    /deep/.el-form-item {
      margin-bottom: 30px !important;
      .el-form-item__content {
        width: 100%;
        .el-button {
          width: 100%;
          height: 48px;
          background: $color;
          border-radius: 5px;
          border-color: $color;
        }
      }
    }
  }
  /deep/.el-dialog {
    min-width: 400px !important;
    .topbox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        font-weight: 550;
      }
    }
    .el-dialog__body {
      padding-top: 10px;
    }
  }
}
</style>